import React from 'react';
import IncomingVehicle from 'src/Images/icons/common/incomingVehicle.svg';

export function VehicleProgress({ percent, theme }) {
  return (
    <div className="vehicle-progress-container">
      <img src={IncomingVehicle} className="vehicle-truck-img" alt="Truck" />
      <div className="vehicle-progress-bar">
        <div
          className={`vehicle-progress-fill ${theme}`}
          style={{ width: `${percent}%` }}
        />
        <span className="vehicle-progress-bar-text text-xl text-bold">
          {percent}%
        </span>
      </div>
    </div>
  );
}

export default VehicleProgress;
